import React from 'react';
import { useParams } from 'react-router-dom';
import TripReviewStepperForm from '../../components/trip-review-stepper-form';

const TripReviewEditContainer = () => {
  const { tripMatchId, reviewId } = useParams<{ tripMatchId: string, reviewId: string }>();

  return (
    <TripReviewStepperForm
      tripMatchId={tripMatchId}
      reviewId={reviewId}
    />
  );
};

export default TripReviewEditContainer;
